export const VIDEO_SPEEDS = {
    NORMAL: 'normal',
    FAST: 'fast',
    FASTER: 'faster',
};
